// extracted by mini-css-extract-plugin
export default {"timeline-items":"styles_timeline-items__H8OYs","timeline-item":"styles_timeline-item__8GZxf"};